<template>
<div>
    <Navbar />
    <Breadcrumbs></Breadcrumbs>
    <EmployeesAssignmentTrip/>
    <Footer />
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import EmployeesAssignmentTrip from '@/components/employees/EmployeesAssignmentTrip.vue'
import Footer from '@/components/Footer.vue';

export default {
    components: {
        Navbar,
        EmployeesAssignmentTrip,
        Footer
    }
}
</script>

<style scoped>

</style>